import MobilePrimaryNav from './MobilePrimaryNav';

export { type MobilePrimaryNavProps } from './MobilePrimaryNav';
export default MobilePrimaryNav;
